<template>
  <v-card style="margin-bottom:1em" class="RelatorioDetalhamentoRetroativo">
    <v-form ref="form" autocomplete="off">
      <v-card-title>
        <div class="title">{{ $tc('title.detalhamento_retroativo', 2) }}</div>
        <v-spacer></v-spacer>
        <v-icon @click="toggleMostrarFiltros">filter_list</v-icon>
      </v-card-title>
      <v-container fluid grid-list-md v-show="mostrarFiltros">
        <metadados-container-layout
          :ordenacao-campos="ordenacaoCampos"
          :campos-formulario="camposFormulario"
          :explode-hierarquia="true"
          :formulario-filtros="true"
          :ignora-inativos="false"
          :ignora-obrigatorios="umFiltroObrigatorioSelecionado"
          :objeto="filtrosDetalhamentoRetroativo"
          ref="container">
          <v-col cols="12" sm="6" md="4" slot="antes">
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="anosSelecionados"
                  multiple
                  chips
                  deletable-chips
                  clearable
                  :label="$t('label.ano')"
                  prepend-icon="event"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker
                v-model="anosSelecionados"
                :active-picker.sync="activePicker"
                reactive
                ref="pickerYear"
                locale="pt-br"
                color="primary"
                :min="minYearFilter"
                :max="maxYearFilter"
                type="year"
                multiple
                @click:year="alteraFiltroAno($event)">
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </v-col>
        </metadados-container-layout>
      </v-container>
      <v-card-actions v-show="mostrarFiltros">
        <v-spacer></v-spacer>
        <v-btn @click="resetaFiltros"
          color="accent"
        >{{$t('label.limpar_filtros')}}</v-btn>
        <v-btn @click="aplicarFiltros"
          color="primary"
        >{{$t('label.exportar')}}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { countRelatorioDetalhamentoRetroativo } from '@/common/resources/magalu-relatorios'; // eslint-disable-line
import MetadadosContainerLayout from '@/shared-components/metadados/MetadadosContainerLayout';
import RelatorioDetalhamentoRetroativoFiltrosCampos from './RelatorioDetalhamentoRetroativoFiltrosCampos';

export default {
  name: 'RelatorioDetalhamentoRetroativo',
  mixins: [
    RelatorioDetalhamentoRetroativoFiltrosCampos,
  ],
  watch: {
    menu(val) {
      if (val) {
        setTimeout(this.activePicker = 'YEAR');
      }
    },
  },
  computed: {
    filtrosFixosClass() {
      return {
        'primary--text': this.filtrosFixados,
        'mr-2': true,
      };
    },
  },
  components: {
    MetadadosContainerLayout,
  },
  data() {
    return {
      ordenacaoCampos: [
        'grupo_fornecedor',
        'categoria',
        'tipo_acao',
      ],
      mostrarFiltros: false,
      filtrosFixados: false,
      filtrosDetalhamentoRetroativo: {},
      umFiltroObrigatorioSelecionado: false,
      limiteRegistrosExportacao: 50000,
      anosSelecionados: [this.moment().format('YYYY')],
      activePicker: null,
      minYearFilter: this.moment().subtract(10, 'y').format('YYYY'),
      maxYearFilter: this.moment().add(5, 'y').format('YYYY'),
    };
  },
  methods: {
    alteraMaxMinYearDatePicker() {
      const maxSelecionado = Math.max.apply(null, this.anosSelecionados);
      const minSelecionado = Math.min.apply(null, this.anosSelecionados);
      this.maxYearFilter = (maxSelecionado + 5).toString();
      this.minYearFilter = (minSelecionado - 10).toString();
    },
    alteraFiltroAno(val) {
      this.$refs.pickerYear.activePicker = 'YEAR';
      const anoSelecionado = val.toString();
      if (!this.anosSelecionados.includes(anoSelecionado)) {
        this.anosSelecionados.push(anoSelecionado);
        this.alteraMaxMinYearDatePicker();
      }
    },
    toggleMostrarFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    resetaFiltros() {
      this.filtrosDetalhamentoRetroativo = {};
    },
    aplicarFiltros() {
      const filtrosAplicados = this.$refs.container.getValoresCamposPadrao();
      filtrosAplicados.ano = this.anosSelecionados;

      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.filtroPeriodoValido(filtrosAplicados)) {
        return;
      }
      const params = {
        ...filtrosAplicados,
      };

      let quantidadeRegistros = 0;

      countRelatorioDetalhamentoRetroativo(params, this.$resource)
        .then((response) => {
          quantidadeRegistros = response.data;
          if (quantidadeRegistros > this.limiteRegistrosExportacao) {
            this.$toast(this.$t('errors.registros.excede_limite_dados', { limite: this.limiteRegistrosExportacao }));
          } else if (quantidadeRegistros > 0) {
            this.$emit('RelatorioDetalhamentoRetroativo__AplicaFiltros',
              params,
              'detalhamento_retroativo',
              'api');
          } else {
            this.$toast(this.$t('errors.registros.nao_ha_dados'));
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    filtroPeriodoValido(filtrosAplicados) {
      if (filtrosAplicados.data_inicio || filtrosAplicados.data_fim) {
        const dtInicio = this.moment(filtrosAplicados.data_inicio, 'YYYY-MM-DD');
        const dtFinal = this.moment(filtrosAplicados.data_fim, 'YYYY-MM-DD');

        if (dtFinal.isBefore(dtInicio)) {
          this.$toast(this.$t('message.data_final_antes_inicial'));
          return false;
        }
        if ((filtrosAplicados.data_inicio && !filtrosAplicados.data_fim)
          || (!filtrosAplicados.data_inicio && filtrosAplicados.data_fim)) {
          this.$toast(this.$t('message.data_final_e_inicial'));
          return false;
        }
      }
      return true;
    },
    salvarFiltrosWorkspace() {
      this.workspace.filtros = this.filtrosDetalhamentoRetroativo;
      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
  },
};
</script>
<style>
  .RelatorioDetalhamentoRetroativo__Opcoes {
    padding: 0 0 0 20px;
    margin-top: 0;
  }
  .RelatorioDetalhamentoRetroativo__Opcoes div.v-input__slot,
  .RelatorioDetalhamentoRetroativo__Opcoes div.v-radio {
    margin-bottom: 0;
  }
  .RelatorioDetalhamentoRetroativo__Opcoes div.v-messages {
    display: none;
  }
  .RelatorioDetalhamentoRetroativo__Opcoes label {
    font-size: 14px;
  }
</style>
